/**
 * The Streembit web wallet, wallet.sbrit.org. Entry point of the esbuild bundle dist/public/app.js, the
 * only script of public/index.html.
 *
 * The page is a single document: the tabs (wallet, send, receive, contracts) are Knockout templates in index.html,
 * bound to the view models under app/models/, and switching between them never calls the server. This
 * file creates the root model, applies the bindings once and wires the page-level events the models
 * cannot see: user activity for the idle lock, the tab being shown or hidden for the polling, and the
 * page being closed.
 *
 * Browser code: the wallet core (streembit-bc-sdk), the node API client (streembit-bc-sdk/api),
 * Knockout, IndexedDB storage (./store), Web APIs only; no Node imports.
 */

import ko from 'knockout';
import { WalletModel } from './models/wallet';

const root = document.getElementById('wallet-app');
if (!root) throw new Error('[wallet] Missing element #wallet-app');

const wallet = new WalletModel();
ko.applyBindings(wallet, root);

for (const type of ['pointerdown', 'keydown']) {
    document.addEventListener(type, () => wallet.touch(), { passive: true });
}
document.addEventListener('visibilitychange', () => wallet.visibilityChanged());
window.addEventListener('pagehide', () => wallet.lock());

wallet.init().catch(err => {
    console.error(`[wallet] ${err instanceof Error ? err.message : String(err)}`);
});
